import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

interface SubscriptionCheckboxesEmittedValue {
  checkPayment: boolean,
  checkSubscription: boolean
};

@Component({
  selector: 'gdp-subscription-change-checkboxes',
  templateUrl: './subscription-change-checkboxes.component.html',
  styleUrls: ['./subscription-change-checkboxes.component.scss']
})
export class SubscriptionChangeCheckboxesComponent implements OnInit {
  public form: UntypedFormGroup;
  @Output() onEmitFormValue: EventEmitter<{ value: SubscriptionCheckboxesEmittedValue, isValid: boolean }> = new EventEmitter();

  constructor(
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      checkPayment: [false, [Validators.requiredTrue]],
      checkSubscription: [false, [Validators.requiredTrue]]
    });
  }

  onChangeInput(): void {
    this.onEmitFormValue.emit({ value: this.form.value, isValid: this.form.valid});
  }
}